<template>
  <f7-page
    @page:beforein="beforein"
  >
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_title_openProject') }}</span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <RegisterNewProjectGreenHouse
        :key="key"
        :list-crop="listCrop"
        :provinces="provinces"
        :list-ground-gh="ground"
        :key-name="keyName"
        read-only
      />
      <GreenHousePartTwo
        :key="`gh-part-two-${key}`"
        :list-irrigation-gh="irrigation"
        :list-manure-gh="manure"
        read-only
      />
    </div>
    <div v-else>
      <RegisterNewProjectOpenAir
        :key="`ex-${key}`"
        :provinces="provinces"
        :list-ground-gh="ground"
        :key-name="keyName"
        read-only
      />
      <OpenAirPartTwo
        :key="`ex-part-two-${key}`"
        read-only
      />
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-button
        :class="`dx-btn-cancel margin-right color-${selection}`"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
      <f7-button
        :class="`dx-btn-success ${selection === 'GreenHouse' ? 'color-orange' : 'open-air'}`"
        raised
        type="success"
        styling-mode="contained"
        name="ButtonSave"
        @click="goToNextPage"
      >
        Editar
      </f7-button>
    </f7-block-footer>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RegisterNewProjectGreenHouse from '../../components/registerProject/registerProjectGreenhouse/index.vue';
import RegisterNewProjectOpenAir from '../../components/registerProject/registerProjectOpenAir/index.vue';
import navbar from '../../components/navbar/NavBar.vue';
import GreenHousePartTwo from '../../components/registerProject/registerProjectGreenhouse/GreenHosePartTwo/index.vue';
import OpenAirPartTwo from '../../components/registerProject/registerProjectOpenAir/OpenAirPartTwo/index.vue';

export default {
  name: 'ViewProject',
  components: {
    RegisterNewProjectGreenHouse,
    RegisterNewProjectOpenAir,
    GreenHousePartTwo,
    OpenAirPartTwo,
    navbar,
  },
  data() {
    return {
      keyName: '',
      key: 0,
    };
  },
  computed: {
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectGreenHouse', ['listCrop', 'provinces', 'ground', 'cont', 'manure', 'irrigation', 'newProject']),
    ...mapState('Database', ['currentProject', 'listGroundGh', 'listIrrigationGh', 'listManureGh']),
    changeTitle() {
      if (this.keyName === '/openProject/') {
        return this.$t('editProject_title');
      }
      return this.$t('LeftPanel_title_newProject');
    },
  },
  methods: {
    async beforein() {
      this.keyName = this.$f7.views.main.router.previousRoute.path;
      this.$f7.preloader.show();
      if (this.currentProject === '' && this.cont === 0) {
        this.setCont(1);
      } else if (this.cont === 0) {
        this.addElementoInIrrigation(this.newProject.irrigation);
        this.addElementoInFloor(this.newProject.ground);
        if (this.newProject.manure) {
          this.addElementoManure(this.newProject.manure);
        }
      }
      try {
        if (this.selection === 'GreenHouse') {
          await this.fetchListCrop();
          await this.fetchProvinces();
          await this.fetchListGround();
          const a1 = [{ name: 'Añadir', id: 1 }];
          const arrayConcat = a1.concat(this.listGroundGh);
          this.setGroundConcated(arrayConcat);
          await this.fetchListIrrigation();
          const a2 = [{ name: '', id: 0 }, { name: 'Añadir', id: 1 }];
          const array2Concat = a2.concat(this.listIrrigationGh);
          this.setIrrigationConcated(array2Concat);
          await this.fetchListManure();
          const array3Concat = a2.concat(this.listManureGh);
          this.setManureConcated(array3Concat);
        }
        if (this.selection === 'OpenAir') {
          await this.fetchListCropEx();
          const a1 = [{ name: '', id: 0 }, { name: 'Añadir', id: 1 }];
          await this.fetchListManure();
          const arrayConcat = a1.concat(this.listManureGh);
          this.setManureConcated(arrayConcat);
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goToHomePage() {
      this.$f7.views.main.router.navigate('/openProject/');
    },
    goToNextPage() {
      this.$f7.views.main.router.navigate('/pageRegisterProject/');
    },
    ...mapActions('ProjectGreenHouse', ['fetchListCrop', 'resetNewProject', 'addElementoInIrrigation',
      'addElementoInFloor', 'addElementoManure', 'fetchProvinces', 'setGroundConcated', 'setCont',
      'setManureConcated', 'setIrrigationConcated']),
    ...mapActions('ProjectOpenAir', ['fetchListCropEx', 'resetNewProjectOpenAir']),
    ...mapActions('Database', ['fetchListGround', 'fetchListIrrigation', 'fetchListManure']),
  },
};
</script>

<style lang="scss">
.breadcrumbs {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  text-transform: uppercase;

  /* Blue Primary Dark */

  color: #23465E;
}
.breadcrumb-title {
  font-weight: 700;
}
.breadcrumb-link {
  cursor: pointer;
}
.color-GreenHouse {
  color: var(--veg-orange)!important;
  background-color: white;
  border: 1px solid var(--veg-orange)!important;
}
.color-OpenAir {
  color: var(--veg-green) !important;
  background-color: white;
  border: 1px solid var(--veg-green) !important;
}
</style>
